import { animate, AnimationBuilder, AnimationPlayer, stagger, style } from '@angular/animations';
import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Directive({
    selector: '[autoShowOnChange]',
})
export class AutoShowOnChangeDirective {

    @Input() public set autoShowOnChange(obj: any) {
        if (this.player) {
            this.player.destroy();
        }

        const metadata = this.fadeInOut();
        const factory = this.builder.build(metadata);
        const player = factory.create(this.element.nativeElement);

        player.play();
    }

    constructor(
        private builder: AnimationBuilder,
        private element: ElementRef
    ) {
    }

    public restrict: string = 'A';

    @Input() public duration: number = 400;

    private player: AnimationPlayer;

    private hideTimeout = '5000ms';

    private fadeInOut() {
        let durationString = this.duration + 'ms';

        return [
            style({ opacity: 0 }),
            animate(`${durationString} ease-in`, style({ opacity: 1 })),
            animate(`${durationString} ${this.hideTimeout} ease-out`, style({ opacity: 0 }))
        ];
    }
}
